import React from 'react';
import ReactDOM from 'react-dom';
import { RouteComponentProps } from 'react-router';
import {
    HashRouter as Router,
    Route,
    Switch,
    Redirect,
    withRouter
} from 'react-router-dom';
// bundleLoader 异步加载路由页面
import BundleLoader from 'lm-bundle-loader';

import 'tools/polyfill';
import 'tools/JsBridge';
import 'tools/wmda';
import { getAbtestForWmda, is58App } from 'tools/utils';
// scrollToTop 路由切换时候页面默认滚动到顶部，可在此控件中配置白名单
import ScrollToTop from 'commons/ScrollToTop';

// import routes
import routes from './routes';

import 'scss_mixin/reset.scss'; // reset 样式
import './common.scss';
import WxMiniHandler from 'commons/WxMiniHandler';
interface IProps extends RouteComponentProps<{}> {

}


// 主页面路由
class MainRouterBase extends React.Component<IProps, {}> {
    componentDidMount(): void {
        const minVersion = '9.10.0';
        if (is58App()) {
            try {
                const { appVersion } = window.WBAPP.common;
                if (window.WBAPP.util.compareVersion(appVersion, minVersion) >= 0) {
                    // 58app开启录屏切屏行为埋点通知
                    console.log('start log_user_action');
                    window.WBAPP.invoke('log_user_action', { in_finance: true }, () => { });
                }
            } catch (e) {
                console.log(e);
            }
        }
    }
    render() {
        return (
            <WxMiniHandler>
                <ScrollToTop>
                    <Switch>
                        {routes.map((route) => route.async ? (
                            <Route path={route.path}
                                exact={route.exact}
                                key={route.name}
                                render={
                                    (props: object) => BundleLoader(route.component, props)
                                } />
                        ) : (<Route
                            path={route.path}
                            exact={route.exact}
                            key={route.name}
                            component={route.component as React.ComponentType<any>} />))}
                        <Redirect to="/page/transfer" />
                    </Switch>
                </ScrollToTop>
            </WxMiniHandler>
        );
    }
}

// 给wmd整体加值ab_test
getAbtestForWmda();

const MainRouter = withRouter(MainRouterBase);

const rootElement = document.getElementById('root');

ReactDOM.render(
    // @ts-ignore
    <Router>
        <div>
            <MainRouter />
        </div>
    </Router>,

    rootElement

);
